<template>
    <div>
        <div class="row mb-1">
            <div class="col-7 col-sm-9 my-auto">
                <ScheduleNames :schedules_for_today="schedules_for_today"/>
            </div>
            <div class="col-5 col-sm-3 text-right">
                <button class="btn btn-sm btn-light" style="max-height: 30px; overflow: hidden;" @click="scrollToNow">
                    <i class="fa-solid fa-arrow-turn-right"></i>&nbsp;Now
                </button>
            </div>
        </div>
        <div class="day-schedule">
            <div class="timeline" ref="timelineRef">
                <div v-for="hour in 24">
                    <DayScheduleBlock v-for="division in divisionsPerHour"
                        :hour="hour - 1" 
                        :division="division" 
                        :bells="filtered_bells(hour - 1, division)" 
                        :style="{ height: `${divisionHeight}px`}"
                        :current_time="current_time"
                        @block-enter="setOffsetTop"
                    />
                </div>
            </div>
            <span class="vertical-line" :style="{ height: `calc(${this.divisionHeight}px * ${this.divisionsPerHour} * 24)`}"></span>
        </div>
    </div>
</template>

<script>
import ScheduleNames from './ScheduleNames.vue';
import DayScheduleBlock from './DayScheduleBlock.vue';
import moment from 'moment';

export default {
    props: ['bells', 'current_time', 'schedules_for_today'],
    components: { DayScheduleBlock, ScheduleNames },
    data() {
        return {
            divisionsPerHour: 2,
            divisionHeight: 120,
            offsetTop: 0
        }
    },
    methods: {
        setOffsetTop(hour, division) {
            const top = ((division - 1) * this.divisionHeight) + (hour * this.divisionHeight * this.divisionsPerHour) - (this.divisionHeight / 2);
            this.offsetTop = top;
        },
        scrollToNow() {
            this.$refs.timelineRef.offsetParent.scrollTop = this.offsetTop;
        },
        filtered_bells(hour, division) {
            return this.bells.filter(bell => {
                const time = moment(bell.schedule_time, 'hh:mm a');
                if(hour !== time.hour())
                    return false;
                if((division === 1 && time.minute() < 30) || (division === 2 && time.minute() >= 30))
                    return true;
            }).sort((a, b) => moment(a.schedule_time, 'hh:mm a') - moment(b.schedule_time, 'hh:mm a'));
        }
    },
    watch: {
        offsetTop(offsetTop) {
            if(offsetTop) this.scrollToNow();
        }
    }
}
</script>

<style scoped>
.day-schedule {
    position: relative;
    overflow-y: auto;
    overflow-x: hidden;
    height: 35vh;
    border: 1px solid #ccc;
}

.timeline {
    position: absolute;
    background-color: #fff;
    width: 100%;
}

span.vertical-line {
    position: absolute;
    display: inline-block;
    /* height = divisionHeight * divisionsPerHour * 24 */
    width: 4rem;
    border-right: 1px solid #aaa;
    pointer-events: none;
}
</style>